<div class="modal-body">
  <h5>{{'EnterNewSignatureDescription' | translate}}:</h5>
  <input class="form-control" id="inputTextBox" [ngModelOptions]="{standalone: true}" [(ngModel)]="text" />
</div>
<div class="modal-footer">
  <!-- ng-init="initText()" -->
  <button class="btn btn-default" (click)="cancel()">{{'Cancel' | translate}}</button>
  <button class="btn btn-default" (click)="ok()">{{'Save' | translate}}</button>
</div>
